// Components
import Loader from '@/components/base/Loader';

export const PreviewPinterest = ({ post, isLoading }) => {
    if (isLoading) {
        return (
            <span
                data-testid="loading"
                className="square block animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"
            />
        );
    }

    return (
        <div
            className="relative flex w-full flex-col items-center overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-10"
            aria-label="preview-pinterest">
            <div className="relative pb-[100px]">
                {/*eslint-disable-next-line @next/next/no-img-element*/}
                <img
                    src={post?.medias?.[0]?.image}
                    className="z-0 w-full rounded-[36px]"
                    alt={post?.title}
                />
                <Loader className="absolute left-1/2 top-1/2 z-1 -ml-5 -mt-5 h-10 w-10 text-icoBlue dark:text-icoBlue" />
                <iframe
                    title="preview-pinterest"
                    src={`https://assets.pinterest.com/ext/embed.html?id=${post?.id}`}
                    width="100%"
                    height="100%"
                    frameborder="0"
                    className="absolute left-0 top-0 z-2"></iframe>
            </div>
        </div>
    );
};
